(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
        .state('room-cost', {
            parent: 'entity',
            url: '/room-cost?page&sort&search',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.roomCost.home.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/room-cost/room-costs.html',
                    controller: 'RoomCostController',
                    controllerAs: 'vm'
                }
            },
            params: {
                page: {
                    value: '1',
                    squash: true
                },
                sort: {
                    value: 'id,asc',
                    squash: true
                },
                search: null
            },
            resolve: {
                pagingParams: ['$stateParams', 'PaginationUtil', function ($stateParams, PaginationUtil) {
                    return {
                        page: PaginationUtil.parsePage($stateParams.page),
                        sort: $stateParams.sort,
                        predicate: PaginationUtil.parsePredicate($stateParams.sort),
                        ascending: PaginationUtil.parseAscending($stateParams.sort),
                        search: $stateParams.search
                    };
                }],
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('roomCost');
                    $translatePartialLoader.addPart('global');
                    return $translate.refresh();
                }]
            }
        })
        .state('room-cost-detail', {
            parent: 'entity',
            url: '/room-cost/{id}',
            data: {
                authorities: ['ROLE_USER'],
                pageTitle: 'sigmasfApp.roomCost.detail.title'
            },
            views: {
                'content@': {
                    templateUrl: 'app/entities/room-cost/room-cost-detail.html',
                    controller: 'RoomCostDetailController',
                    controllerAs: 'vm'
                }
            },
            resolve: {
                translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                    $translatePartialLoader.addPart('roomCost');
                    return $translate.refresh();
                }],
                entity: ['$stateParams', 'RoomCost', function($stateParams, RoomCost) {
                    return RoomCost.get({id : $stateParams.id});
                }]
            }
        })
        .state('room-cost.new', {
            parent: 'room-cost',
            url: '/new',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-cost/room-cost-dialog.html',
                    controller: 'RoomCostDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: function () {
                            return {
                                cost: null,
                                id: null
                            };
                        }
                    }
                }).result.then(function() {
                    $state.go('room-cost', null, { reload: true });
                }, function() {
                    $state.go('room-cost');
                });
            }]
        })
        .state('room-cost.edit', {
            parent: 'room-cost',
            url: '/{id}/edit',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-cost/room-cost-dialog.html',
                    controller: 'RoomCostDialogController',
                    controllerAs: 'vm',
                    backdrop: 'static',
                    size: 'lg',
                    resolve: {
                        entity: ['RoomCost', function(RoomCost) {
                            return RoomCost.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('room-cost', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        })
        .state('room-cost.delete', {
            parent: 'room-cost',
            url: '/{id}/delete',
            data: {
                authorities: ['ROLE_USER']
            },
            onEnter: ['$stateParams', '$state', '$uibModal', function($stateParams, $state, $uibModal) {
                $uibModal.open({
                    templateUrl: 'app/entities/room-cost/room-cost-delete-dialog.html',
                    controller: 'RoomCostDeleteController',
                    controllerAs: 'vm',
                    size: 'md',
                    resolve: {
                        entity: ['RoomCost', function(RoomCost) {
                            return RoomCost.get({id : $stateParams.id});
                        }]
                    }
                }).result.then(function() {
                    $state.go('room-cost', null, { reload: true });
                }, function() {
                    $state.go('^');
                });
            }]
        });
    }

})();
